import { render, staticRenderFns } from "./trip-events-filter.vue?vue&type=template&id=b53bd22e&"
import script from "./trip-events-filter.vue.js?vue&type=script&lang=js&"
export * from "./trip-events-filter.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports